var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 8.7346C21.5 6.69676 20.6572 4.7424 19.1568 3.30143C17.6565 1.86046 15.6217 1.05093 13.5 1.05093C11.3783 1.05093 9.34344 1.86046 7.84315 3.30143C6.34285 4.7424 5.5 6.69676 5.5 8.7346C5.5 17.6989 1.5 20.2601 1.5 20.2601H25.5C25.5 20.2601 21.5 17.6989 21.5 8.7346Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1133 22.8546C15.8789 23.2183 15.5425 23.5203 15.1376 23.7301C14.7328 23.94 14.2739 24.0506 13.8067 24.0506C13.3395 24.0506 12.8805 23.94 12.4757 23.7301C12.0709 23.5203 11.7344 23.2183 11.5 22.8546"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1133 22.8546C15.8789 23.2183 15.5425 23.5203 15.1376 23.7301C14.7328 23.94 14.2739 24.0506 13.8067 24.0506C13.3395 24.0506 12.8805 23.94 12.4757 23.7301C12.0709 23.5203 11.7344 23.2183 11.5 22.8546",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.b28bf135048c90013d00b83de0878dba.svg";
export { ForwardRef as ReactComponent };